var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.painting)?_c('div',[_vm._v("Grafik wird erzeugt...")]):_vm._e(),_c('canvas',{ref:"canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }